import React from "react";
import Swal from "sweetalert2";
import { createVacationBeingHere } from "../../api/VacationBeingHere";

const CreateVacationBeingHere = ({ onSuccess }) => {
  const [vacationBeingHere, setVacationBeingHere] = React.useState({
    name: "",
    introduction: "",
  });
  // state for image upload
  const [file, setFile] = React.useState(null);
  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", file);
    Object.entries(vacationBeingHere).forEach(([key, value]) =>
      formData.append(key, value)
    );
    const response = createVacationBeingHere(formData);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Vacation Being Here Created!",
            text: "You have successfully created a vacation being here!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputComapanyName">Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            onChange={(e) =>
              setVacationBeingHere({
                ...vacationBeingHere,
                name: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputImage">Image</label>
          <input
            type="file"
            className="form-control"
            name="image"
            onChange={handleFileChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputIntroduction">Introduction</label>
          <textarea
            className="form-control"
            id="exampleInputIntroduction"
            rows="3"
            name="introduction"
            onChange={(e) =>
              setVacationBeingHere({
                ...vacationBeingHere,
                introduction: e.target.value,
              })
            }
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Save
        </button>
      </form>
    </>
  );
};

export default CreateVacationBeingHere;
